import Chart from 'chart.js';
import 'chartjs-plugin-colorschemes';

export function createChart(ctx, values) {
    // Update data with chart settings
    for (const ds of values.data.datasets) {
        //ds.backgroundColor = 'rgba(255, 255, 255, 1.0)';
        //ds.borderColor = 'rgba(255, 99, 132, 1)';
        ds.pointRadius = 0;
        ds.borderWidth = 2;
        ds.fill = false;
        ds.showLine = true;
    }
    new Chart(ctx, {
        type: 'line',
        data: values.data,
        options: {
            plugins: {
                colorschemes: {
                    scheme: 'tableau.Tableau10'
                }
            },
            //backgroundColor: '#FFF',
            //borderColor: '#FFF',
            title: {
                display: true,
                text: values.title
            },
            scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: values.xLabel
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: values.yLabel
                    },
                    ticks: {
                        beginAtZero: true,
                        max: values.yMax
                    }
                }]
            }
        }
    });
}

export function make_change(handler) {
    return (e) => {
        handler(e.target.value);
    }
}

export function make_prop_change(name, data, callback) {
    return (e) => {
        let new_data = {...data};
        new_data[name] = e.target.value;
        callback(new_data);
    };
}

